import { render, staticRenderFns } from "./CharacterDetail.vue?vue&type=template&id=1ef5cd52&scoped=true&"
import script from "./CharacterDetail.vue?vue&type=script&lang=js&"
export * from "./CharacterDetail.vue?vue&type=script&lang=js&"
import style0 from "./CharacterDetail.vue?vue&type=style&index=0&id=1ef5cd52&lang=less&scoped=true&"
import style1 from "./CharacterDetail.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../voicecasting.sk/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ef5cd52",
  null
  
)

export default component.exports